import gql from 'graphql-tag';

/**
 * Shared fragment for every BackgroundTask payload — used by the tray
 * query and the `backgroundTaskUpdated` subscription so the shape stays
 * in sync. Per `mrbl-ai/server-rust` `docs/modules/admin/background-task-entity-ref-frontend.md`,
 * `entityRef` is the source of truth for click-through; `resultUrl` is
 * deprecated and kept here only for burn-in fallback on legacy AI Chat
 * rows. Remove `resultUrl` in the follow-up cleanup once burn-in completes.
 */
export const backgroundTaskFields = gql`
  fragment BackgroundTaskFields on BackgroundTaskOutput {
    id
    taskType
    status
    title
    progressPct
    completedAt
    error
    failureKind
    resultUrl
    runId
    targetEntityId
    entityRef {
      kind
      id
    }
    createdAt
    updatedAt
  }
`;

export const backgroundTasksTrayQuery = gql`
  query BackgroundTasksTray($input: BackgroundTasksTrayInput!) {
    backgroundTasksTray(input: $input) {
      items {
        ...BackgroundTaskFields
      }
      hasNextPage
      nextCursor
    }
  }
  ${backgroundTaskFields}
`;
